import FilesDownload from './FilesDownload.vue'

export default FilesDownload
